{
  "version": 1,
  "asset_id": "ac8a13b3-8887-4199-905f-30ed186968ce",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/ac8a13b3-8887-4199-905f-30ed186968ce/band-tubing-1200.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/ac8a13b3-8887-4199-905f-30ed186968ce/band-tubing-1200.jpg",
  "original_filename": "band-tubing-1200.jpg",
  "size": 87095,
  "content_type": "image/jpeg",
  "created_at": "2026-09-20T00:20:56Z"
}
